import confirm from './confirm';

class Dialog {
  static success = props => confirm({
    ...props,
    type: 'positive',
    name: 'check circle outline',
    color: 'green',
  });

  static error = props => confirm({
    ...props,
    type: 'negative',
    name: 'times circle outline',
    color: 'red',
  });

  static info = props => confirm({
    ...props,
    type: 'primary',
    name: 'info',
    color: 'blue',
  });
}

export default Dialog;
